﻿import * as React from "react";
import { List, ListItem, ListItemText } from "@material-ui/core";

export interface ISearchResult {
    releaseNoteID: number;
    applicationID: number;
    brandedName: string;
    publishDate: string;
    version: string;
    noteText: string;
    noteTextLower: string;
    searchWeight: number;
}

interface ISearchResultsProps {
    searchResults: ISearchResult[];
}

export const SearchResults: React.FunctionComponent<ISearchResultsProps> = (
    props,
): React.ReactElement => {
    let searchResultsList;

    if (props.searchResults != null) {
        searchResultsList = props.searchResults.map((searchResult) => (
            <div key={searchResult.releaseNoteID}>
                <ListItem
                    className={`releasenotes-listitem`}
                    key={searchResult.releaseNoteID}
                >
                    <ListItemText
                        disableTypography={true}
                        primary={
                            <div className={`releasenotes-list-secondary`}>
                                {searchResult.brandedName}
                            </div>
                        }
                        secondary={
                            <div className={`releasenotes-list-tertiary`}>
                                <div>{`Last updated: ${searchResult.publishDate.substr(
                                    0,
                                    10,
                                )}`}</div>
                                <div>{`V${searchResult.version}`}</div>
                                {searchResult.noteText.length < 100 ? (
                                    <div>{searchResult.noteText}</div>
                                ) : (
                                    <div>{`${searchResult.noteText.substr(
                                        0,
                                        99,
                                    )}...`}</div>
                                )}
                            </div>
                        }
                    />
                </ListItem>
                <div className={`releasenotes-linebreak`} />
            </div>
        ));
    } else {
        searchResultsList = (
            <ListItem>
                <ListItemText primary={`Loading`} secondary={``} />
            </ListItem>
        );
    }

    return (
        <List className={`releasenotes-scrollable`}>{searchResultsList}</List>
    );
};
